import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/utils";

const badgeVariants = cva(
	"inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-medium tracking-wide uppercase border",
	{
		variants: {
			tone: {
				neutral:
					"border-gray-200 dark:border-white/[0.08] bg-gray-50 dark:bg-white/[0.04] text-gray-700 dark:text-gray-300",
				accent:
					"border-orange-200 dark:border-amber-400/30 bg-orange-50 dark:bg-amber-400/10 text-orange-700 dark:text-amber-300",
				success:
					"border-emerald-200 dark:border-emerald-500/30 bg-emerald-50 dark:bg-emerald-500/10 text-emerald-700 dark:text-emerald-300",
				warning:
					"border-amber-200 dark:border-amber-500/30 bg-amber-50 dark:bg-amber-500/10 text-amber-700 dark:text-amber-300",
				danger:
					"border-red-200 dark:border-red-500/30 bg-red-50 dark:bg-red-500/10 text-red-700 dark:text-red-300",
				info: "border-sky-200 dark:border-sky-500/30 bg-sky-50 dark:bg-sky-500/10 text-sky-700 dark:text-sky-300",
				violet:
					"border-violet-200 dark:border-violet-500/30 bg-violet-50 dark:bg-violet-500/10 text-violet-700 dark:text-violet-300",
			},
			shape: {
				default: "",
				dot: "px-1 py-0 leading-none",
			},
		},
		defaultVariants: {
			tone: "neutral",
			shape: "default",
		},
	},
);

export interface BadgeProps
	extends React.HTMLAttributes<HTMLSpanElement>,
		VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
	({ className, tone, shape, ...props }, ref) => {
		return (
			<span
				ref={ref}
				className={cn(badgeVariants({ tone, shape, className }))}
				{...props}
			/>
		);
	},
);
Badge.displayName = "Badge";

export { Badge, badgeVariants };
